export default {
    list: {
        title: "Payements",
        name: 'payments',
        class: "min-h-screen flex-1 mt-1 bg-gray-100  items-center",
        sousTable: false,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                method: true,
                name: "Actions",
                buttons: [
                    {
                        text: "New Payement",
                        icon: "add",
                        action:"addPay",
                        link: '/payments/new',
                        color: 'primary'
                    },
                    {
                        text: "Change status",
                        icon: "update",
                        action:"changestatus",
                        color: 'primary',
                        class:''
                    },
                    // {
                    //     text: "Print Invoice",
                    //     icon: "print",
                    //     action:"printdInvoice",
                    //     color: 'primary',
                    //     class:''
                    // },
                ],
            }
        },
        columns: [
            {
                type:"checkbox",
                elements: [{
                   items: [{
                       class: "",
                       type: "checkbox",
                   }, ],
               }, ]
            },
            {
                name: "ID",
                elements: [{
                    items: [{
                        name: "id",
                        class: "text-center",
                    }, ],
                }, ]
            },
            {
                name: "Seller",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "seller",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold text-gray-700",
                                icone: "contacts"
                            },
                            // {
                            //     name: "email",
                            //     class: "font-light text-gray-700",
                            //     icone: "email"
                            // }
                        ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Payement methode",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "method",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Nb orders",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "count",
                        type: "text",
                    }],
                }, ]
            },
            // {
            //     name: "details",
            //     model: "payments",
            //     title: 'Orders'
            // },
            {
                name: "Date payement",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "date",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Période",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "periode",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "TOTAL Amount",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "amount",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Status",
                class: "",
                elements: [{
                    items: [{
                        class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                        name: "status",
                        options: (item) => {
                            switch (item) {
                                case 'pending':
                                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                                    break;
                                case 'processed':
                                    return "color:rgb(8, 194, 226); border-color: rgb(8, 194, 226);"
                                    break;
                            }
                        },
                    }],
                }, ]
            },
        ],
        columnsDialog: {
            details: 'details',
            elements: [{
                    class: "",
                    name: "ID",
                    items: [{
                        referent: "order",
                        name: "id",
                    }, ]
                },
                {
                    class: "",
                    name: "CUSTOMER",
                    items: [{
                        referent: "order",
                        field:"customer",
                        name: "fullName",
                    }, ]
                },
                {
                    class: "",
                    name: "TOTAL PRICE",
                    items: [{
                        referent: "order",
                        name: "totalPrice",
                    }, ]
                },
                {
                    class: "",
                    name: "Confirmation fees",
                    items: [{
                        name: "confirmation_vat",
                    }, ]
                },
                {
                    class: "",
                    name: "Shipping fees",
                    items: [{
                        name: "shipping_vat",
                    }, ]
                },
                {
                    class: "",
                    name: "Refund fees",
                    items: [{
                        name: "shipping_refund_vat",
                    }, ]
                },
                {
                    class: "",
                    name: "Change fees",
                    items: [{
                        name: "shipping_change_vat",
                    }, ]
                },
                {
                    class: "",
                    name: "Total",
                    items: [{
                        name: "amount",
                    }, ]
                },
            ]
        },
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-center",
            elements: [
                // {
                //     icone: "print",
                //     color: "success",
                //     key: 'print',
                //     role: true,
                //     id: "",
                //     tooltip: "Print",
                // },
                {
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/payments/detail',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'orders',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "id payment, amount ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [
                    {
                        label: "Status",
                        key: "status",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Method payement",
                        key: "method",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Date payement",
                        key: "date",
                        value: null,
                        placeholder: "Date",
                        type: "date",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    },
                ],
            },
        },
    },
}